import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferSaleStatusQuery } from './type';

/**
 * 数字商品 offer 和 game service offer 批量上架/下架
  POST /product/offerManage/updateOfferStatus
  接口ID：263628553
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628553
 */
export const postOfferSaleStatus = (data: OfferSaleStatusQuery[]): AxiosPromise => {
  return request({
    url: '/product/offerManage/updateOfferStatus',
    method: 'post',
    data
  });
};
